/**
 * Séances en cours (2026-11-02) : dès qu'un enregistrement démarre dans une
 * salle de réunion, un bandeau l'annonce à ceux qui peuvent y entrer
 * (« Coaching en cours - Ascension Ads »), et un clic y mène à pied.
 *
 * Le type de séance se choisit par salle dans l'éditeur (`properties.sessionType`
 * d'une zone `meeting-room`) ; sans type, « Séance en cours ».
 * Sous-chemin `@campus/core/sessions` côté serveur, jamais le barrel.
 */

export const SESSION_TYPES = [
  { id: 'coaching', label: 'Coaching' },
  { id: 'prospection', label: 'Prospection' },
  { id: 'mentorat', label: 'Mentorat' },
  { id: 'atelier', label: 'Atelier' },
  { id: 'reunion', label: 'Réunion' },
] as const;

export type SessionType = (typeof SESSION_TYPES)[number]['id'];

/** Type de séance d'une zone (propriétés JSON), null si absent ou inconnu. */
export function sessionTypeOf(properties: unknown): SessionType | null {
  const raw = properties && typeof properties === 'object' ? (properties as Record<string, unknown>).sessionType : undefined;
  return SESSION_TYPES.some((t) => t.id === raw) ? (raw as SessionType) : null;
}

/** « Coaching en cours », ou « Séance en cours » sans type. */
export function sessionTitle(type: SessionType | null): string {
  const label = SESSION_TYPES.find((t) => t.id === type)?.label;
  return `${label ?? 'Séance'} en cours`;
}

/** Séance en cours vue par une personne (GET /media/recordings/live). */
export interface LiveSessionDTO {
  recordingId: string;
  roomId: string;
  roomName: string;
  zoneSlug: string;
  zoneName: string;
  sessionType: SessionType | null;
  startedAt: string;
  /** Centre de la salle, en pixels de la carte (pour y aller à pied). */
  x: number;
  y: number;
}
